import {jsonMember, jsonObject} from 'typedjson';
import {LoraPacketUplink} from '@/model/lora/LoraPacket/LoraPacketUplink';

@jsonObject
export class LoraPacketUplinkJoinRequest extends LoraPacketUplink {

  @jsonMember({name: 'joinEUI'})
  public JoinEUI!: string;

  @jsonMember({name: 'devEUI'})
  public DeviceEUI!: string;

  @jsonMember({name: 'devNonce'})
  public DeviceNonce!: number;
}
